<template>
    <div class="footer">
        Copyright © 2023 西安奇点能源技术有限公司
        <a href="#">陕ICP备20010223号-3</a>
    </div>
</template>

<script>
export default {
  data(){
    return {
        
    }
  }
}
</script>

<style lang="less" scoped>
    .footer {
        position: fixed;
        left: 40%;
        bottom: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        height: 50px;
        font-size: 12px;
        
        a {
            margin-left: 25px;
        }
        
    }
</style>